import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const adminPromoCodesRoutes: RouteObject[] = [
  {
    path: 'admin/promo-codes',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_PROMO_CODES, title: 'Codes promo' },
  },
  {
    path: 'admin/promo-codes/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_PROMO_CODE_FORM, title: 'Nouveau code promo' },
  },
  {
    path: 'admin/promo-codes/:promoCodeId/edit',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_PROMO_CODE_FORM, title: 'Modifier le code promo' },
  },
];
